import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Tooltip, Paper, Grid } from '@material-ui/core';
import BiztranControls from "../../biztran_controls/BiztranControls";
import { Link } from 'react-router-dom';
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import CreateProduct from "./CreateProduct";
import CreatePriceList from "./CreatePriceList";
import ProductBulkImport from "./ProductBulkImport";


const Product = () => {
    const [ProductID, setProductID] = useState('')
    const [ProductName, setProductName] = useState('');
    const [ProductType, setProductType] = useState('');
    const [ProductGroup, setProductGroup] = useState('');
    const [DisableAddNew, setDisableAddNew] = useState(false);
    const [ModelCode, setModelCode] = useState('');
    const [Specifications, setSpecifications] = useState('');
    const [ShortDesc, setShortDesc] = useState('');
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [Count, setCount] = useState();
    const [isOpen, setOpen] = useState(false);
    const [isOpenPL, setOpenPL] = useState(false);
    const [isOpenImport, setOpenImport] = useState(false);
    const [response, fetchData] = UseFetchData();

    const handleOpenModal = () => {
        setOpen(true);
        setProductID('');
    }

    const handleOpenPriceList = () => {
        setOpenPL(true);
        setProductID('');
    }

    const handleOpenProductBulkIm = () => {
        setOpenImport(true);
        setProductID('');
    }

    const PopulateData = () => {
        // debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("ProductName", ProductName);
        bodyFormData.append("ProductGroup", ProductGroup);
        bodyFormData.append("ModelCode", ModelCode);
        bodyFormData.append("Specifications", Specifications);
        fetchData("product/List", bodyFormData);
    }

    useEffect(() => {
        // debugger;
        if (sessionStorage.UID == '101B316C-5D92-4066-82AB-35741EE773F8' || sessionStorage.UserType == "Admin") {

            setDisableAddNew(false);
        }
        else {
            setDisableAddNew(true);
        }

    });

    useEffect(() => {
        // debugger;
        PopulateData();
    }, []);

    useEffect(() => {
        const gridCols = [
            {
                field: "id",
                headerName: ".",
                renderCell: (params) => (<strong> <Link to={{ pathname: "/product/ProductView", state: { ProductID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 70,
            },
            {
                field: "ProductGroup",
                headerName: "Product Group",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "ProductName",
                headerName: "Product Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
                renderCell: (params) => (
                    <Tooltip title={params.row.ProductName} >
                        <span className="table-cell-trucate">{params.row.ProductName}</span>
                    </Tooltip>
                ),
            },
            // {
            //     field: "ProductType",
            //     headerName: "Product Type",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 220,
            // },
            // {
            //     field: "DisplayTitle",
            //     headerName: "Display Title",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 220,
            //     renderCell: (params) => (
            //         <Tooltip title={params.row.DisplayTitle} >
            //             <span className="table-cell-trucate">{params.row.DisplayTitle}</span>
            //         </Tooltip>
            //     ),
            // },
            // {
            //     field: "Make",
            //     headerName: "Make",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            // },
            // {
            //     field: "ModelCode",
            //     headerName: "Model Code",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            // },
            // {
            //     field: "Specification",
            //     headerName: "Specification",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            // },
            // {
            //     field: "ShortDescription",
            //     headerName: "Short Description",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            //     renderCell: (params) => (
            //         <Tooltip title={params.row.ShortDescription} >
            //             <span className="table-cell-trucate">{params.row.ShortDescription}</span>
            //         </Tooltip>
            //     ),
            // },
            // {
            //     field: "LongDescription",
            //     headerName: "LongDescription",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            //     renderCell: (params) => (
            //         <Tooltip title={params.row.LongDescription} >
            //             <span className="table-cell-trucate">{params.row.LongDescription}</span>
            //         </Tooltip>
            //     ),
            // },
        ];
        setColumns(gridCols);
        setRows(response);
        setCount(response.length);
        //if (response !== undefined && response.length > 0) {
        //// debugger;
        // setRows(response);
        //setCount(response.length);
        // }
    }, [response]);

    return (
        <Paper elevation={0} >

            <Grid container direction="row" style={{ marginTop: -10 }} >
                <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20 }}>
                    <BiztranControls.Input
                        label="Product Name"
                        id="ProductName"
                        style={{ width: 'maxWidth' }}
                        onChange={(e) => setProductName(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20 }}>
                    <BiztranControls.Input
                        label="Product Group"
                        id="ProductGroup"
                        style={{ width: 'maxWidth' }}
                        onChange={(e) => setProductGroup(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20 }}>
                    <BiztranControls.Input
                        label="Model Code"
                        id="ModelCode"
                        style={{ width: 'maxWidth' }}
                        onChange={(e) => setModelCode(e.target.value)}
                    />
                </Grid>
            </Grid>
            <Grid container direction="row" style={{ marginTop: 0 }} spacing={0.5}>
                <Grid item xs={12} sm={3} md={2} lg={2} xl={2} style={{ marginTop: 20 }}>
                    <BiztranControls.Input
                        label="Specifications"
                        id="Specifications"
                        style={{ width: 'maxWidth' }}
                        onChange={(e) => setSpecifications(e.target.value)}
                    />
                </Grid>
                <Grid container xs={12} sm={8} md={4} lg={6} xl={2} direction="row" style={{ marginTop: 20 }}>
                    <Grid item >
                        <BiztranControls.Button
                            responsive='true'
                            text="SEARCH"
                            startIcon={<SearchIcon />}
                            onClick={() => {
                                PopulateData();
                            }}
                        />
                    </Grid>
                    <Grid item style={{ marginTop: 10 }} >
                        <label style={{ fontWeight: 'bold', width: 10 }}>{Count}</label>
                    </Grid>
                    <Grid item >
                        <BiztranControls.Button
                            responsive='true'
                            text="ADD NEW"
                            disabled={DisableAddNew}
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={() => {
                                handleOpenModal();
                            }}
                        />
                    </Grid>
                    <Grid item >
                        <BiztranControls.Button
                            responsive='true'
                            text="Export PL"
                            // style={{ width: "120" }}
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={() => {
                                handleOpenPriceList();
                            }}
                        />
                    </Grid>
                    <Grid item >
                        <BiztranControls.Button
                            responsive='true'
                            text="Import"
                            // style={{ width: "120" }}
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={() => {
                                handleOpenProductBulkIm();
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <BiztranControls.DataGrid
                rowHeight={25}
                headerHeight={34}
                rows={rows}
                columns={columns}
                checkboxSelection={false}
                //hideFooterPagination={true}
                //hideFooter={true}
                //Height="480px"
                //Height="700px"
                autoHeight={true}
                Width="100%"
            />
            <ModalFrame
                title="Product Details"
                maxWidth="sm"
                isOpen={isOpen}
                headerAlign="center"
                setOpen={setOpen}
            >
                <CreateProduct
                    ProductID={ProductID}
                    setOpen={setOpen}
                    PopulateData={PopulateData}
                />
            </ModalFrame>
            <ModalFrame
                title="Export Price List"
                maxWidth="sm"
                isOpen={isOpenPL}
                headerAlign="center"
                setOpen={setOpenPL}
            >
                <CreatePriceList
                    ProductID={ProductID}
                    setOpen={setOpenPL}
                    PopulateData={PopulateData}
                />
            </ModalFrame>
            <ModalFrame
                title="Product Import"
                maxWidth="lg"
                isOpen={isOpenImport}
                headerAlign="center"
                setOpen={setOpenImport}
            >
                <ProductBulkImport />
                {/* <CreatePriceList
                    ProductID={ProductID}
                    setOpen={setOpenPL}
                    PopulateData={PopulateData}
                /> */}
            </ModalFrame>
        </Paper >
    );
};

export default Product;
